import { MeetingRoomsOverviewController } from "../components/MeetingRoomsOverviewController"

export function ServiceCenterMeetingRooms() {
    return <MeetingRoomsOverviewController />
}
